import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { SharedModule } from "@secca/shared/shared.module";
import { UtilsModule } from "src/app/utils/utils.module";
import { CaseTaskTableComponent } from "./case-task-table/case-task-table.component";
import { CaseTaskComponent } from "./case-task.component";

@NgModule({
  declarations: [
    CaseTaskComponent,
    CaseTaskTableComponent,
   ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    UtilsModule,
    SharedModule,
  ],
  exports: [
    CaseTaskComponent
  ]
})
export class CaseTaskModule { }